// Registry of RISE event modules for the retailer_tools domain.
//
// Each entry maps a RISE event name to a lazy loader for its codegen class.
// When adding a new RISE event, add one line here after running codegen
// (ic schema code subscriptions). The key is your event name from the
// Blueprint YAML filename (e.g., "catalog.search_performed" for
// catalog.search_performed.yml).
//
// See: https://instacart.atlassian.net/wiki/spaces/Catalog/pages/6553108566/Adding+RISE+Events+to+IPP

export const eventLoaders: Record<string, () => Promise<Record<string, any>>> = {
  'app.page_view': () =>
    import('../../../rise-events/domains/retailer_tools/event_app_dot_page_view_v1'),
  'app.launched': () =>
    import('../../../rise-events/domains/retailer_tools/event_app_dot_launched_v1'),
  'navigation.action': () =>
    import('../../../rise-events/domains/retailer_tools/event_navigation_dot_action_v1'),
  'dashboard.viewed': () =>
    import('../../../rise-events/domains/retailer_tools/event_dashboard_dot_viewed_v1'),
  'auth_refresh.attempted': () =>
    import('../../../rise-events/domains/retailer_tools/event_auth_refresh_dot_attempted_v1'),
  'auth_refresh.success': () =>
    import('../../../rise-events/domains/retailer_tools/event_auth_refresh_dot_success_v1'),
  'care_customer_details.interaction': () =>
    import('../../../rise-events/domains/retailer_tools/event_care_customer_details_dot_interaction_v1'),
  // NOTE TO DEV: Add your RISE events here...
}

export const commonLoader = () =>
  import('../../../rise-events/domains/retailer_tools/common_external')
